const TAB_ITEM_STANDARD = 'tabStandard'
const TAB_ITEM_ACTION_1 = 'tabAction1'
const TAB_ITEM_ACTION_2 = 'tabAction2'
const TAB_ITEM_IMAGES = 'tabImages'
const TAB_ITEM_RECAP = 'tabRecap'
const TAB_ITEM_ORDER_HISTORY = 'tabOrderHistory'
const TAB_ITEM_ENGAGEMENT_HISTORY = 'tabEngagementHistory'
const TAB_ITEM_INFO = 'tabInfo'

export const NEW_VISIT_REPORT_TABS: string[] = [
  TAB_ITEM_STANDARD,
  TAB_ITEM_ACTION_1,
  TAB_ITEM_IMAGES,
]

export const VIEW_VISIT_REPORT_TABS_V1: string[] = [
  TAB_ITEM_STANDARD,
  TAB_ITEM_ACTION_1,
  TAB_ITEM_ACTION_2,
  TAB_ITEM_IMAGES,
]

export const VIEW_VISIT_REPORT_TABS_V4: string[] = [
  TAB_ITEM_STANDARD,
  TAB_ITEM_INFO,
  TAB_ITEM_ACTION_1,
  TAB_ITEM_IMAGES,
]

export const HISTORY_TABS: string[] = [
  TAB_ITEM_RECAP,
  TAB_ITEM_ORDER_HISTORY,
  TAB_ITEM_ENGAGEMENT_HISTORY,
]
